import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { RestApiService } from '@/services'

import { ApplicationState } from '@/state/root.models'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'
import { jsonToQueryString } from '@/utils'

import { PlayerCardActionTypes } from '../constants'
import { PLAYER_CARD } from './api.routes'
import { PlayerCardModels } from '../'

const apiService: RestApiService = Container.get(RestApiService)

export const getPlayersThunk = createAsyncThunk(
  PlayerCardActionTypes.GET_PLAYERS,
  async (payload: PlayerCardModels.GetPlayersPayload, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoadingFullAction(true))

      const { auth } = thunkAPI.getState() as ApplicationState

      apiService.requestParams = {
        method: 'GET',
        endpoint: PLAYER_CARD.GET_PLAYERS,
        queries: jsonToQueryString(
          {
            ...payload,
            brandId: auth.brand.siteId.toString(),
            //brandId: 'f1c808ad-dda5-4aa5-8553-63f99562ad05',
          },
          true,
        ),
        isIncentiveAPI: true,
      }

      const response: PlayerCardModels.GetPlayersResponse =
        await apiService.getData(auth.brand.siteId.toString(), auth.token)

      thunkAPI.dispatch(setLoadingFullAction(false))

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
    }
  },
)

export const getPlayersExtraReducer = (
  builder: ActionReducerMapBuilder<PlayerCardModels.PlayerCardState>,
) => {
  builder.addCase(getPlayersThunk.pending, (state) => {
    state.isLoadingSearch = true
  })
  builder.addCase(getPlayersThunk.fulfilled, (state, { payload }) => {
    state.isLoadingSearch = false
    state.players = payload.data
    state.paginationSearch = {
      total: payload.total,
      page: payload.page,
      pages: payload.pages,
      limit: payload.limit,
    }
  })
}
